import { useEffect, useState, useRef } from "react";
import { AUTHORIZATION, CENTRE, HOSTNAME } from "../../common/constants";
import { Alert, Box, Button, Grid, Paper, Snackbar, TextField } from "@mui/material";
import HorizontalNav from "../../components/HorizontalNav";
import {
    textboxStyle,
} from "../../utils/styleObjs";
import "./BadgePrint.css";
import Badge from "./Badge";
import { useLocation } from "react-router-dom";

const BadgePrintPage = () => {
    const [sp, setSp] = useState("");
    const [sewadarBadge, setSewadarBadge] = useState("");
    const [snack, setSnack] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const onFieldChange = (val) => {
        setSewadarBadge(val);
    };
    const navLinks = [{ key: 0, label: "Home", path: "/home" }, { key: 1, label: "Badge Print Form", path: "/badgePrint" }];

    const location = useLocation();
    useEffect(() => {
        setSp(localStorage.getItem(CENTRE));
    }, [sp]);

    const printRef = useRef();

    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;
        window.print()
        document.body.innerHTML = originalContents
    }

    return (
        <>
            <Snackbar
                open={snack.open}
                autoHideDuration={6000}
                onClose={() => setSnack({ ...snack, open: false })}
            >
                <Alert
                    elevation={6}
                    variant="filled"
                    onClose={() => setSnack({ ...snack, open: false })}
                    severity={snack.severity}
                    sx={{ width: "100%" }}
                >
                    {snack.msg}
                </Alert>
            </Snackbar>
            <HorizontalNav navLinks={navLinks} pageName="Badge Print Page" />
            <Paper ref={printRef} id="print-section" elevation={10} variant="outlined" sx={{
                width: '297mm !important', height: '210mm !important'
            }}>
                <Box sx={{
                    width: '297mm !important', height: '210mm !important',
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'wrap',
                    alignContent: 'flex-start'
                }} p='6.35mm' id="print-paper">
                    {location.state.sewadarIds.map((sewadarId) => {
                        return (
                            <Box sx={{ width: '57mm', height: '89mm', border: '1.25px solid black', paddingBottom:'2px'}} className="printBadge">
                                <Badge sewadarId={sewadarId} />
                            </Box>
                        )
                    })}
                </Box>
            </Paper>
            <Button fullWidth variant="contained" onClick={handlePrint}>
                Print
            </Button>
        </>
    );
};

export default BadgePrintPage;
